import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import times from 'lodash/times'
import media from '../../../utils/style'

const PaginationWrapper = styled.div`
  position: absolute;
  bottom: 5px;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 10;

  ${media.MediumScreenUp`
    bottom: 10px;
  `}
`

const Page = styled.button`
  border: none;
  margin: 0.125em;
  padding: 0.5em;
  opacity: ${(props) => (props.isActive ? 1 : 0.65)};
  background-color: ${(props) =>
    props.isActive ? props.theme.colors.blue : props.theme.colors.blue_op40};
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    opacity: ${(props) => (props.isActive ? 1 : 0.85)};
    background-color: ${(props) =>
      !props.isActive && props.theme.colors.blue_op65};
  }

  ${media.MediumScreenUp`
    padding: 0.9em;
  `}
`

export default function Pagination(props) {
  const { currentSlide, slideCount, handleClickSlideChange } = props

  let pages = []
  times(slideCount, (i) => {
    const isActive = currentSlide === i
    pages.push(
      <Page
        isActive={isActive}
        onClick={handleClickSlideChange}
        data-slide-index={i}
        key={`slide-index-${i}`}
        aria-label={`Slide-${i}`}
      />
    )
  })

  return <PaginationWrapper>{pages}</PaginationWrapper>
}

Pagination.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  handleClickSlideChange: PropTypes.func.isRequired
}
